import { BillType } from '@/@types/bill.types';
import { Bill } from '@/types/bill.types';
import { CurrencyCode } from '@clearbanc/data-common-types';
import yup from '@clearbanc/validation/dist/utils/yupExtensions';
import _ from 'lodash';

type BillSchema = Record<
  BillType,
  { amountCents: { min: number; max: number }; payOutCurrency: CurrencyCode[] }
>;

/**
 * If we adopt this approach in more places we should create/find a way to parse yup schemas more generically.
 * For now, only a few specific properties are being parsed, so this is good enough
 */
export function parseBillSchema(
  schema: Record<BillType, yup.SchemaObjectDescription>,
): BillSchema {
  return Object.entries(schema).reduce(
    (acc: BillSchema, [billType, billConfig]) => {
      const { amountCents, payOutCurrency } = billConfig.fields as Record<
        keyof Bill,
        yup.SchemaDescription
      >;

      const amountCentsMinMax = _.keyBy(amountCents?.tests, 'name');

      acc[billType as BillType] = {
        amountCents: {
          min: amountCentsMinMax.min?.params?.min as number,
          max: amountCentsMinMax.max?.params?.max as number,
        },
        payOutCurrency: payOutCurrency?.oneOf as CurrencyCode[],
      };

      return acc;
    },
    {} as BillSchema,
  );
}
